import { apiBuilder } from "@zodios/core";
import { z } from "zod";

const trmnlSchema = z.object({
  email: z.string().email(),
  id: z.string(),
  market_place: z.string(),
});

export const trmnlApiDefinitions = apiBuilder({
  method: "post",
  path: "/api/mobile/org/trmnl/",
  alias: "trmnluser",
  parameters: [
    {
      name: "trmnl",
      type: "Body",
      schema: trmnlSchema,
      description: "TRMNL user data",
    },
  ],
  response: z.unknown(),
}).build();
